









































import store from '@/store'
import ApiClient from '@/js/api.js'
import YellowButton from '@/views/atoms/YellowButton.vue'
import ManageRow from '@/views/organisms/ManageRow.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import SelectBox from '@/views/atoms/SelectBox.vue'
import TextArea from '@/views/atoms/TextArea.vue'
import ErrorLabel from '@/views/atoms/ErrorLabel.vue'
import ContentsTemplate from '@/views/templates/ContentsTemplate.vue'

export default
  name: 'Inquiry'

  components: {
    YellowButton
    ManageRow
    TextBox
    SelectBox
    TextArea
    ErrorLabel
    ContentsTemplate
  }

  data: () ->
    inquiryList:
      '商品に関して': '商品に関して'
      'サイトに関して': 'サイトに関して'
      'その他': 'その他'
    inquiryStyle: ''

  created: () ->
    if @.$route.query.r != '1'
      store.dispatch('initPostParam')
    @.$emit('header_title', 'お問い合わせフォーム')

  computed: {
    isDetailChange: () ->
      @inquiryStyle = store.getters.getPostParam.inquiry_style
      return store.getters.isSetDetail
  }

  methods: {
    execute_button: (e) ->
      e.preventDefault()
      e.stopPropagation()
      api = new ApiClient()
      data = await api.post('/member/inquiry/confirm')
      if data.errors.length == 0
        @$router.push '/contents/inquiry/confirm'

  }
